const CloudPayments = {
  publicId: "pk_bb7f944b9c44f64711d950a761ab9", // public ID of site (from back office)
  // description: "Подписка на курсы FaceStudio", // offer's title / description
  // amount: 1499, // subscription amount
  currency: "RUB",
  skin: "mini", // skin of the widget: 'classic', 'modern', 'mini'
  data: {
    cloudPayments: {
      // create a monthly subscription
      recurrent: {
        interval: "Month", // Day, Week, Month
        period: 1
      }
      // courseId: "1234-1234-1234" // Firebase Course ID
      // promocodeId: "FooBar1" // Firebase Promocode ID
    }
  }
};

export default {
  CloudPayments
};
